import { render, staticRenderFns, recyclableRender, components } from "./uni-icons.vue?vue&type=template&id=0bf90c00&scoped=true&"
var renderjs
import script from "./uni-icons.vue?vue&type=script&lang=js&"
export * from "./uni-icons.vue?vue&type=script&lang=js&"
import style0 from "./uni-icons.vue?vue&type=style&index=0&id=0bf90c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf90c00",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uni-icons/uni-icons.vue"
export default component.exports